import intl from 'react-intl-universal';
import { useEffect, useState } from 'react';
import { Checkbox, Row, Col, message } from 'antd';
import { ProColumnType } from '@ant-design/pro-components';
// import { DragSortTable } from '@ant-design/pro-table';
import { FormItemValueType } from '../../dynamicForm';
import { setDiyList } from '@/api/common';
import type { DiyFieldItem, DynamicTableType } from '@/type/dynamicTable';
import { default as Modal } from '@/components/CssModal';

import style from '../index.less';
import { getDataIndex } from '../utils/index';
import { isArray, pull, uniq } from 'lodash';

interface Props {
    show: boolean;
    // isShowAllField: boolean;
    tableType?: DynamicTableType;
    columns: ProColumnType<any, FormItemValueType>[];

    showFields: DiyFieldItem[];
    onSuccess?: (result: DiyFieldItem[]) => void;
    onClose: () => void;
}

type dependencyCol = {
    [key: string | number]: (string | number)[];
};

const TableSettings: React.FC<Props> = ({
    show,
    // isShowAllField,
    tableType,
    columns = [],
    showFields,
    onSuccess,
    onClose,
}) => {
    const [value, setValue] = useState<(string | number)[]>([]);
    // 父关联的所有子项, 父字段作为 key，所有关联的子项
    const [parentCols, setParentCols] = useState<dependencyCol | null>(null);
    // 子 关联的所有 父项， 子字段作为 key, 所有关联的父项
    const [childrenCols, setChildrenCols] = useState<dependencyCol | null>(
        null,
    );

    useEffect(() => {
        init();
        if (showFields?.length) {
            const value = [];

            columns.forEach((col) => {
                const target = showFields.find(
                    (field) => field.field === getDataIndex(col.dataIndex),
                );

                if (!target || target.status) {
                    value.push(getDataIndex(col.dataIndex));
                }
            });
            // showFields.forEach((item) => {
            //     if (item.status) {
            //         value.push(item.field);
            //     }
            // });
            setValue(value);
        } else {
            resetSetting();
        }
    }, [showFields]);

    const init = () => {
        const dependencyCols = columns.filter(
            (col) => col.valueType === 'dependency',
        );

        const parentCols: dependencyCol = {};
        const childrenCols: dependencyCol = {};

        dependencyCols.forEach((col) => {
            // 确保有关联值
            const dataIndex = getDataIndex(col.dataIndex);
            if (isArray(col.name)) {
                if (!childrenCols[dataIndex]) {
                    childrenCols[dataIndex] = [];
                }
                childrenCols[dataIndex].push(...(col.name || []));

                col.name?.forEach((item) => {
                    if (!parentCols[item]) {
                        parentCols[item] = [];
                    }
                    parentCols[item].push(col.dataIndex);
                });
            }
        });

        setParentCols(parentCols);
        setChildrenCols(childrenCols);
    };

    const onSave = () => {
        const selectFields: DiyFieldItem[] = columns.map((col) => {
            return {
                field: getDataIndex(col.dataIndex),
                status: value.includes(getDataIndex(col.dataIndex)),
            };
        });

        setDiyList({
            type: tableType,
            selectFields,
        }).then(() => {
            message.success(intl.get('保存成功'));
            onSuccess?.(selectFields);
        });
    };

    const onChange = (e: string[], item) => {
        const val = e.target?.checked;
        const dataIndex = getDataIndex(item.dataIndex);
        // 当前项 所有关联的父项
        const parents = childrenCols?.[dataIndex];
        // 当前项 所有关联的子项
        const childs = parentCols?.[dataIndex];

        if (val) {
            value.push(dataIndex);
            // 这里直接 push  后面去重， 这里是因为有互相为父子的字段
            value.push(...(parents || []));
        } else {
            pull(value, ...(childs || []), dataIndex);
        }

        // 这里 value 去重
        setValue(uniq(value));
    };

    const resetSetting = () => {
        setValue(columns.map((item) => getDataIndex(item.dataIndex)));
    };

    return (
        <Modal
            width={800}
            destroyOnClose={true}
            title={intl.get('自定义查询')}
            open={show}
            onOk={onSave}
            onCancel={onClose}
        >
            <Checkbox.Group
                style={{ width: '100%' }}
                // onChange={onChange}
                value={value}
            >
                <Row>
                    {columns?.map((item, index) => (
                        <Col
                            className={style.filter_item}
                            key={item.dataIndex}
                            span={8}
                        >
                            {/* 前 3 个字段不可以取消勾选配置 */}
                            <Checkbox
                                onChange={(value) => {
                                    onChange(value, item);
                                }}
                                disabled={index < 3}
                                value={getDataIndex(item.dataIndex)}
                            >
                                {item.title}
                            </Checkbox>
                        </Col>
                    ))}
                </Row>
            </Checkbox.Group>
        </Modal>
    );
};

export default TableSettings;
